import { FlowContainer } from '@labb/dx-engine';
import { createContext, useContext, type MutableRefObject } from 'react';

type FlowContainerContextValue = {
  container: FlowContainer | null;
  isNavigatingBack: boolean;
  isNavigatingBackRef: MutableRefObject<boolean>;
  isScreenActionInFlight: boolean;
  setScreenActionInFlight: (inFlight: boolean) => void;
};

const defaultNavigatingBackRef: MutableRefObject<boolean> = { current: false };
const noopSetScreenActionInFlight: (inFlight: boolean) => void = () => undefined;

export const FlowContainerContext = createContext<FlowContainerContextValue>({
  container: null,
  isNavigatingBack: false,
  isNavigatingBackRef: defaultNavigatingBackRef,
  isScreenActionInFlight: false,
  setScreenActionInFlight: noopSetScreenActionInFlight,
});

export function useFlowContainer(): FlowContainer | null {
  return useContext(FlowContainerContext).container;
}

export function useIsNavigatingBack(): boolean {
  const { isNavigatingBack, isNavigatingBackRef } = useContext(FlowContainerContext);
  return isNavigatingBack || isNavigatingBackRef.current;
}

export function useIsNavigatingBackRef(): MutableRefObject<boolean> {
  return useContext(FlowContainerContext).isNavigatingBackRef;
}

export function useScreenActionInFlight(): {
  isScreenActionInFlight: boolean;
  setScreenActionInFlight: (inFlight: boolean) => void;
} {
  const { isScreenActionInFlight, setScreenActionInFlight } = useContext(FlowContainerContext);
  return { isScreenActionInFlight, setScreenActionInFlight };
}
